import React from "react";
import "./settingstab.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Settingstab() {
  const navigate = useNavigate();
  const { route } = useParams();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === "admin";

  return (
    <div className="container">
      <div className="setting-tab">
        <Link
          onClick={() => navigate("/settings/account")}
          className={route.includes("account") && "active"}
        >
          Account
        </Link>
        {isAdmin && (
          <Link
            onClick={() => navigate("/settings/users")}
            className={route.includes("users") ? "active" : ""}
          >
            Users
          </Link>
        )}
      </div>
    </div>
  );
}
